import classNames from 'classnames';
import { forwardRef } from 'react';

import './Scrollbar.scss';

export interface ScrollbarProps {
  style?: React.CSSProperties;
  children?: React.ReactNode;
  className?: string;
}

const Scrollbar = forwardRef<HTMLDivElement, ScrollbarProps>(
  ({ children, className, style, ...otherProps }, ref) => {
    return (
      <div
        className={classNames(
          'Mfw-Scrollbar h-full overflow-y-auto overflow-x-hidden',
          className,
        )}
        style={style}
        ref={ref}
        {...otherProps}
      >
        {children}
      </div>
    );
  },
);

Scrollbar.displayName = 'Scrollbar';
export default Scrollbar;
